module.exports = __webpack_public_path__ + "static/2001-07-22_09.17.32-39e2a39d47614a673c722edec7429957.jpg";